import { ALTERAR_CRIANCA_COLO } from '../types'

export default function alterarCriacaColo (pedido, reserva) {
  return {
    type: ALTERAR_CRIANCA_COLO,
    payload: { pedido, reserva }
  }
}
